import http from './../services/Api';
import saveAs from 'save-as';

const NOT_FOUND_MESSAGE = 'Seu relatório não foi encontrado. Por favor, gere um novo relatório para o período';
const DOWNLOAD_ERROR_MESSAGE = 'Não foi possível baixar o relatório. Por favor, tente novamente';

export async function fetchReport(url) {
    try {
        const response = await http.get(url, { responseType: 'blob' });
        return response.data;
    } catch (e) {
        console.log(e);
        throw new Error(e.response && e.response.status === 404 ? NOT_FOUND_MESSAGE : DOWNLOAD_ERROR_MESSAGE);
    }
}

export async function downloadReport(url, filename) {
    saveAs(await fetchReport(url), filename);
}
